import { isValuePresent } from '@neslotech/utils';

export const isPresent = (value?: string | number | object): boolean => {
  return isValuePresent(value);
};

export function isNotZero(value: string | number): boolean {
  return value !== 0 && value !== '0';
}

export function isGreaterThanZero(value: number): boolean {
  return value > 0;
}

export function isNotNegative(value: number): boolean {
  return value >= 0;
}

export function isEmail(value: string): boolean {
  return matchRegexp(
    value,
    // eslint-disable-next-line max-len
    /^((([a-z]|\d|[!#$%&'*+/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)(((([\x20])*)?([\x20])+)?(([--\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([--\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*((([\x20])*)?([\x20])+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
  );
}

export function isUrl(value: string): boolean {
  return matchRegexp(
    value,
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/i
  );
}

export function isNumeric(value: unknown): boolean {
  if (typeof value === 'number') {
    return true;
  }
  return matchRegexp(value, /^[-+]?(?:\d*[.])?\d+$/);
}

export function isAlpha(value: unknown): boolean {
  return matchRegexp(value, /^[A-Z]+$/i);
}

export function isAlphaAllowSpaces(value: unknown): boolean {
  return matchRegexp(value, /^[A-Za-zÀ-ÿ\s]+$/i);
}

export function isAlphanumeric(value: unknown): boolean {
  return matchRegexp(value, /^[0-9A-Z]+$/i);
}

function matchRegexp(value: unknown, regexp: RegExp): boolean {
  return !isPresent(String(value)) || regexp.test(String(value));
}

export function isDate(value: Date | string | number): boolean {
  return !value ? true : !isNaN(Date.parse(String(value)));
}
